import axios from 'axios';

const baseURL = '';
const devURL = baseURL + '/dev';

/* eslint-disable */
export const addToQueue = async data => {
  try {
    const response = await axios.post(devURL + '/add_to_queue', data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
};

export const getQueue = async data => {
  const response = await axios.get(devURL + '/get_queue');
  return response.data;
};

export const getQueueLength = async () => {
  const response = await axios.get(devURL + '/get_queue_length');
  return response.data;
};

export const getPhysicalQueueLength = async () => {
  const response = await axios.get(devURL + '/get_pq_length');
  return response.data;
};

export const setQueueLength = async physicalQueueLengthInMS => {
  const data = {
    queueLength: physicalQueueLengthInMS,
  };
  const response = await axios.post(devURL + '/update_physical_queue', data);
  return response.data;
};

export const getSlots = async data => {
  const response = await axios.get(devURL + '/get_slots');
  return response.data;
};

export const finalizeSlot = async data => {
  const response = await axios.post(devURL + '/finalize_slot', data);
  return response.data;
};
